import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withRouter } from 'react-router';

import { fetchNotificationsPanelData } from './store/actions';
import { selectConnectionForNotifications } from '../balanceSheetManagement/store/actions';
import { NotificationSectionName } from './constants';
import Spinner from '../shared/spinner.component';

const generalClasses = ['badge', 'notification-count'];

const getNotificationCountClasses = notification => {
  const { notificationSection } = notification;
  if ([NotificationSectionName.configurationDiagnostics].includes(notificationSection)) {
    const { warning, error } = notification;
    return classnames(
      ...generalClasses,
      {
        'badge-info': warning + error === 0,
        'badge-secondary': warning > 0 && error === 0,
        'badge-danger': error > 0,
      }
    );
  }

  const { numOfNotifications } = notification;
  if ([
    NotificationSectionName.unpostedGLJournals,
    NotificationSectionName.taxEntriesPendingApproval,
  ].includes(notificationSection)) {
    return classnames(
      ...generalClasses,
      {
        'badge-secondary': numOfNotifications === 0,
        'badge-info': numOfNotifications > 0,
      }
    );
  }

  if ([
    NotificationSectionName.declinedTaxEntries,
    NotificationSectionName.taxEntriesToApprove,
  ].includes(notificationSection)) {
    return classnames(
      ...generalClasses,
      {
        'badge-secondary': numOfNotifications === 0,
        'badge-danger': numOfNotifications > 0,
      }
    );
  }
};

class NotificationsWidget extends PureComponent {
  static propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.shape({
      notificationSection: PropTypes.string,
      url: PropTypes.string,
      tab: PropTypes.string,
      sortOrder: PropTypes.number,
      numOfNotifications: PropTypes.number,
      key: PropTypes.string,
      description: PropTypes.string,
    })).isRequired,
    fetchNotificationsPanelData: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    selectConnectionForNotifications: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    this.props.fetchNotificationsPanelData();
  }

  handleNotificationClickFactory = url => () => {
    this.props.selectConnectionForNotifications('ALL');
    this.props.history.push(url);
  };

  renderNotification = notification => {
    const handleClick = this.handleNotificationClickFactory(notification.url);

    return (
      <div className="notification" key={notification.key}>
        <div
          className={getNotificationCountClasses(notification)}
          onClick={handleClick}
        >
          <span>{notification.numOfNotifications}</span>
        </div>
        <div className="notification-content">
          <div>
            <h4 className="notification-type-header">
              <button className="btn btn-link notification-link" onClick={handleClick}>
                {notification.notificationSection}
              </button>
            </h4>
          </div>
          <div className="notification-body" onClick={handleClick}>
            {notification.description}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const notifications = this.props.notifications;
    const { isLoading } = this.props;

    return (
      <div className="notifications-widget a-panel mb-3">
        <div className="card-header"><h5>Notifications</h5></div>
        <div className="card-body">
          {
            isLoading
              ? <Spinner />
              : notifications.map(this.renderNotification)
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps({ dashboard: { notifications } }) {
  return {
    notifications,
  };
}

export default connect(mapStateToProps, {
  fetchNotificationsPanelData,
  selectConnectionForNotifications,
})(withRouter(NotificationsWidget));
